import { Navigate, useRoutes } from "react-router-dom";
// config
import MyAuthGuard from "src/auth/MyAuthGuard";

//
import { PATH_AFTER_LOGIN } from "../config-global";
import {
  AdminListPage,
  BlueprintListPage,
  ChangePasswordPage,
  Dashboard,
  ForgotPasswordPage,
  LoginPage,
  NewPasswordPage,
  Page404,
  PasswordResetSuccessPage,
  ProgramListPage,
  PublicAssessmentPage,
  PublicLearningPage,
  PublicLinkListPage,
  ReportDetailsPage,
  ReportListPage,
  SchedulePage,
  ScheduleReportPage,
  StudentDetailsPage,
  StudentListPage,
  StudentWeeklyReportPage,
  TeacherCreatePage,
  TeacherDetailsPage,
  TeacherListPage,
  TeacherReportPage,
  TeacherWorkReportPage,
  UserActivityListPage,
  VerifyResetTokenPage,
} from "./elements";
// auth
import HeaderOnlyLayout from "src/layouts/dashboard/HeaderOnlyLayout";
import StudentProfilePage from "src/pages/student/StudentProfilePage";
import GuestGuard from "../auth/GuestGuard";
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";

// ?-----------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
      ],
    },

    {
      path: "auth",
      children: [
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },

        {
          element: <CompactLayout />,
          children: [
            { path: "forgot-password", element: <ForgotPasswordPage /> },
            { path: "verify-reset-token", element: <VerifyResetTokenPage /> },
            { path: "reset-password", element: <NewPasswordPage /> },
            {
              path: "password-reset-success",
              element: <PasswordResetSuccessPage />,
            },
            { path: "reset-password/:token", element: <ChangePasswordPage /> },
          ],
        },
      ],
    },

    {
      path: "student",
      element: (
        <MyAuthGuard>
          <HeaderOnlyLayout />
        </MyAuthGuard>
      ),
      children: [
        { element: <Navigate to="/student/details" replace />, index: true },
        {
          path: ":tab",
          element: <StudentProfilePage />,
        },
      ],
    },

    // Dashboard
    {
      path: "dashboard",
      element: (
        <MyAuthGuard>
          <DashboardLayout />
        </MyAuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "app", element: <Dashboard /> },

        {
          path: "student",
          children: [
            {
              element: <Navigate to="/dashboard/student/list" replace />,
              index: true,
            },
            { path: "list", element: <StudentListPage /> },
            { path: ":id/:tab", element: <StudentDetailsPage /> },
            {
              path: ":id/assessments/:assessment_id/add-score",
              element: <StudentDetailsPage />,
            },
            {
              path: ":id/:tab/:assessment_id/add-score",
              element: <StudentDetailsPage />,
            },
          ],
        },
        {
          path: "teacher",
          children: [
            {
              element: <Navigate to="/dashboard/teacher/list" replace />,
              index: true,
            },
            { path: "list", element: <TeacherListPage /> },
            { path: ":id/:tab", element: <TeacherDetailsPage /> },
            { path: "new", element: <TeacherCreatePage /> },
          ],
        },
        { path: "teacher-report", element: <TeacherReportPage /> },
        { path: "teacher-work-report", element: <TeacherWorkReportPage /> },
        { path: "schedule", element: <SchedulePage /> },
        {
          path: "course",
          children: [
            {
              element: <Navigate to="/dashboard/course/list" replace />,
              index: true,
            },
            { path: "list", element: <ProgramListPage /> },
          ],
        },
        {
          path: "blueprint",
          children: [
            {
              element: <Navigate to="/dashboard/blueprint/list" replace />,
              index: true,
            },
            { path: "list", element: <BlueprintListPage /> },
          ],
        },
        {
          path: "admin",
          children: [
            {
              element: <Navigate to="/dashboard/admin/list" replace />,
              index: true,
            },
            { path: "list", element: <AdminListPage /> },
          ],
        },
        {
          path: "public-link",
          children: [
            {
              element: <Navigate to="/dashboard/public-link/list" replace />,
              index: true,
            },
            { path: "list", element: <PublicLinkListPage /> },
          ],
        },

        {
          path: "user-activity",
          children: [
            { path: "", element: <UserActivityListPage />, index: true },
            { path: ":id/:tab", element: <UserActivityListPage /> },
          ],
        },

        {
          path: "report",
          children: [
            {
              element: <Navigate to="/dashboard/report/list" replace />,
              index: true,
            },
            { path: "list", element: <ReportListPage /> },
            {
              path: "weekly-student-report",
              element: <StudentWeeklyReportPage />,
            },
            { path: "schedule", element: <ScheduleReportPage /> },
            { path: ":id", element: <ReportDetailsPage /> },
          ],
        },
      ],
    },

    {
      element: <CompactLayout />,
      children: [
        { path: "404", element: <Page404 /> },

        {
          path: "student-learning-plan/:token",
          element: <PublicLearningPage />,
        },
        {
          path: "student-assessment-report/:token",
          element: <PublicAssessmentPage />,
        },
      ],
    },
    // { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
